import type { AppState } from "../state/actions.ts";
import { render } from "../rendering/renderer.ts";

function wrapText(ctx: CanvasRenderingContext2D, text: string, maxWidth: number): string[][] {
  const lines: string[][] = [];
  for (const paragraph of text.split("\n")) {
    if (paragraph === "") {
      lines.push([""]);
      continue;
    }
    const words = paragraph.split(/\s+/);
    let currentLine: string[] = [];
    for (const word of words) {
      const testLine = [...currentLine, word].join(" ");
      if (ctx.measureText(testLine).width > maxWidth && currentLine.length > 0) {
        lines.push(currentLine);
        currentLine = [word];
      } else {
        currentLine.push(word);
      }
    }
    if (currentLine.length > 0) lines.push(currentLine);
  }
  return lines;
}

function stripHtml(html: string): string {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.innerText || div.textContent || "";
}

export function exportPng(state: AppState): void {
  const { canvasWidth: w, canvasHeight: h } = state;
  const dpr = window.devicePixelRatio || 1;
  const canvas = document.createElement("canvas");
  canvas.width = w * dpr;
  canvas.height = h * dpr;
  const ctx = canvas.getContext("2d");
  if (!ctx) return;

  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  render(ctx, state.objects, null, w, h);

  const { fontFamily, fontSize, color, lineHeight } = state.textStyle;
  ctx.font = `${fontSize}px ${fontFamily}`;
  ctx.fillStyle = color;
  ctx.textAlign = "left";
  ctx.textBaseline = "top";

  const textZoneX = 70;
  const textZoneWidth = w - 140;
  const textZoneY = 60;
  const plainText = stripHtml(state.textHtml);
  const wrapped = wrapText(ctx, plainText, textZoneWidth);

  let y = textZoneY;
  for (const line of wrapped) {
    ctx.fillText(line.join(" "), textZoneX, y);
    y += fontSize * lineHeight;
  }

  canvas.toBlob((blob) => {
    if (!blob) return;
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "telegram.png";
    a.click();
    URL.revokeObjectURL(url);
  }, "image/png");
}
